module.exports = __webpack_public_path__ + "static/blueshirt-0ef06cae22317f298a6cc73b47e442c5.png";